module.exports = __webpack_public_path__ + "html/subscription-app-sumo-plan_8ff2c31c0cdb3f0205cee0e3a7bc0e43.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/settings/subscription/subscription-app-sumo-plan.html
// module id = SDy6
// module chunks = 59